// packages/i18n/src/shared/utils/patternToRegex.ts

const escapeRe = (s: string) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

/**
 * Compile a URL-map pattern (e.g. "/bookings/manage/:bookingNumber") into a
 * full-match regex plus the ordered param names its capture groups bind.
 * The `:` of a param marker is not a regex metacharacter, so escaping the
 * literal parts first leaves the markers intact for the replace below.
 */
export function patternToRegex(pattern: string): { regex: RegExp; keys: string[] } {
  const keys: string[] = [];
  const reStr =
    '^' +
    escapeRe(pattern).replace(/:([A-Za-z0-9_]+)/g, (_m: string, key: string) => {
      keys.push(key);
      return '([^/]+)';
    }) +
    '$';
  return { regex: new RegExp(reStr), keys };
}
